import { Event } from "../events/Event";
import { GButton } from "./GButton";
import { HideFlags } from "../Const";
export class GTreeNode {
    constructor(isFolder, resURL, addIndent) {
        this._expanded = false;
        this._level = 0;
        this._indentLevel = 0;
        this._addIndent = 0;
        this._isFolder = isFolder;
        if (resURL)
            this._resURL = resURL;
        if (addIndent)
            this._addIndent = addIndent;
        this._children = [];
    }
    get expanded() {
        return this._expanded;
    }
    set expanded(value) {
        this._setExpanded(value);
    }
    _setExpanded(value, byEvent) {
        if (this._expanded != value) {
            this._expanded = value;
            if (this._tree && this.isFolder) {
                if (this._expanded)
                    this._tree._afterExpanded(this, byEvent);
                else
                    this._tree._afterCollapsed(this, byEvent);
            }
            if (this._expandCtrler)
                this._expandCtrler.selectedIndex = this.expanded ? 1 : 0;
        }
    }
    get isFolder() {
        return this._isFolder || this._children.length > 0;
    }
    set isFolder(value) {
        if (this._isFolder != value) {
            this._isFolder = value;
            if (this._leafController)
                this._leafController.selectedIndex = this.isFolder ? 0 : 1;
        }
    }
    get addIndent() {
        return this._addIndent;
    }
    set addIndent(value) {
        this._addIndent = value;
    }
    get parent() {
        return this._parent;
    }
    get text() {
        if (this._cell)
            return this._cell.text;
        else
            return null;
    }
    set text(value) {
        if (this._cell)
            this._cell.text = value;
    }
    get icon() {
        if (this._cell)
            return this._cell.icon;
        else
            return null;
    }
    set icon(value) {
        if (this._cell)
            this._cell.icon = value;
    }
    get cell() {
        return this._cell;
    }
    set cell(value) {
        if (this._cell) {
            this._cell.treeNode = null;
            this._indentObj = null;
            this._leafController = null;
            if (this._expandCtrler)
                this._expandCtrler.off(Event.CHANGED, this, this._expandedStateChanged);
            let btn = this._cell.findChild("expandButton");
            if (btn)
                btn.off(Event.CLICK, this, this._clickExpandButton);
            this._cell.off(Event.MOUSE_DOWN, this, this._cellMouseDown);
        }
        this._cell = value;
        this._cellFromPool = false;
        if (this._cell) {
            this._cell.treeNode = this;
            this._indentObj = this._cell.findChild("indent");
            if (this._tree && this._indentObj)
                this._indentObj.width = Math.max(this._indentLevel - 1, 0) * this._tree.indent;
            this._expandCtrler = this._cell.getController("expanded");
            if (this._expandCtrler) {
                this._expandCtrler.on(Event.CHANGED, this, this._expandedStateChanged);
                this._expandCtrler.selectedIndex = this.expanded ? 1 : 0;
            }
            let btn = this._cell.findChild("expandButton");
            if (btn)
                btn.on(Event.CLICK, this, this._clickExpandButton);
            this._leafController = this._cell.getController("leaf");
            if (this._leafController)
                this._leafController.selectedIndex = this.isFolder ? 0 : 1;
            this._cell.on(Event.MOUSE_DOWN, this, this._cellMouseDown);
        }
    }
    createCell(tree) {
        if (this._cell)
            return;
        let child = (this._tree || tree).itemPool.take(this._resURL ? this._resURL : "");
        if (!child)
            throw new Error("cannot create tree node object.");
        child.hideFlags |= HideFlags.HideAndDontSave;
        if (child instanceof GButton)
            child.selected = false;
        this.cell = child;
        this._cellFromPool = true;
    }
    get level() {
        return this._level;
    }
    addChild(child) {
        this.addChildAt(child, this._children.length);
        return child;
    }
    addChildAt(child, index) {
        if (!child)
            throw new Error("child is null");
        let numChildren = this._children.length;
        if (index >= 0 && index <= numChildren) {
            if (child._parent == this) {
                this.setChildIndex(child, index);
            }
            else {
                if (child._parent)
                    child._parent.removeChild(child);
                if (index == numChildren)
                    this._children.push(child);
                else
                    this._children.splice(index, 0, child);
                if (this.isFolder && this._leafController)
                    this._leafController.selectedIndex = 0;
                child._parent = this;
                child._level = this._level + 1;
                child._indentLevel = this._indentLevel + 1 + child._addIndent;
                child._setTree(this._tree);
                if (this._tree && this == this._tree.rootNode || this._cell && this._cell.parent && this._expanded)
                    this._tree._afterInserted(child);
            }
            return child;
        }
        else {
            throw new Error(`Invalid child index ${index}`);
        }
    }
    removeChild(child) {
        let childIndex = this._children.indexOf(child);
        if (childIndex != -1) {
            this.removeChildAt(childIndex);
        }
        return child;
    }
    removeChildAt(index) {
        if (index >= 0 && index < this.numChildren) {
            let child = this._children[index];
            this._children.splice(index, 1);
            if (!this.isFolder && this._leafController)
                this._leafController.selectedIndex = 1;
            child._parent = null;
            if (this._tree) {
                child._setTree(null);
                this._tree._afterRemoved(child);
            }
            return child;
        }
        else {
            throw new Error(`Invalid child index ${index}`);
        }
    }
    removeChildren(beginIndex, endIndex) {
        beginIndex = beginIndex || 0;
        if (endIndex == null)
            endIndex = -1;
        if (endIndex < 0 || endIndex >= this.numChildren)
            endIndex = this.numChildren - 1;
        for (let i = beginIndex; i <= endIndex; ++i)
            this.removeChildAt(beginIndex);
    }
    getChildAt(index) {
        if (index >= 0 && index < this.numChildren)
            return this._children[index];
        else
            throw new Error(`Invalid child index ${index}`);
    }
    getChildIndex(child) {
        return this._children.indexOf(child);
    }
    getPrevSibling() {
        if (this._parent == null)
            return null;
        let i = this._parent._children.indexOf(this);
        if (i <= 0)
            return null;
        return this._parent._children[i - 1];
    }
    getNextSibling() {
        if (this._parent == null)
            return null;
        let i = this._parent._children.indexOf(this);
        if (i < 0 || i >= this._parent._children.length - 1)
            return null;
        return this._parent._children[i + 1];
    }
    getLastVisibleDecendant() {
        let ret = this.findLastVisibleChild(this);
        return ret === this ? null : ret;
    }
    findLastVisibleChild(parentNode) {
        var _a;
        for (let i = parentNode.children.length - 1; i >= 0; i--) {
            let node = parentNode.children[i];
            if (((_a = node.cell) === null || _a === void 0 ? void 0 : _a.parent) && node.cell.visible)
                return this.findLastVisibleChild(node) || node;
            else if (node.children.length > 0 && node.expanded) {
                let ret = this.findLastVisibleChild(node);
                if (ret)
                    return ret;
            }
        }
        return null;
    }
    setChildIndex(child, index) {
        let oldIndex = this._children.indexOf(child);
        if (oldIndex == -1)
            throw new Error("Not a child of this container");
        let cnt = this._children.length;
        if (index < 0)
            index = 0;
        else if (index > cnt)
            index = cnt;
        if (oldIndex == index)
            return;
        this._children.splice(oldIndex, 1);
        this._children.splice(index, 0, child);
        if (this._tree && this == this._tree.rootNode || this._cell && this._cell.parent && this._expanded)
            this._tree._afterMoved(child);
    }
    swapChildren(child1, child2) {
        let index1 = this._children.indexOf(child1);
        let index2 = this._children.indexOf(child2);
        if (index1 == -1 || index2 == -1)
            throw new Error("Not a child of this container");
        this.swapChildrenAt(index1, index2);
    }
    swapChildrenAt(index1, index2) {
        let child1 = this._children[index1];
        let child2 = this._children[index2];
        this._children[index1] = child2;
        this._children[index2] = child1;
        if (this._tree && this == this._tree.rootNode || this._cell && this._cell.parent && this._expanded) {
            if (index1 < index2) {
                this._tree._afterMoved(child2);
                this._tree._afterMoved(child1);
            }
            else {
                this._tree._afterMoved(child1);
                this._tree._afterMoved(child2);
            }
        }
    }
    get numChildren() {
        return this._children.length;
    }
    get children() {
        return this._children;
    }
    expandToRoot() {
        let p = this;
        while (p) {
            p.expanded = true;
            p = p.parent;
        }
    }
    get tree() {
        return this._tree;
    }
    _setTree(value) {
        this._tree = value;
        if (this._tree && this._indentObj)
            this._indentObj.width = Math.max(this._indentLevel - 1, 0) * this._tree.indent;
        if (this._tree && this._tree.treeNodeWillExpand && this._expanded)
            this._tree.treeNodeWillExpand(this, true);
        let cnt = this._children.length;
        for (let i = 0; i < cnt; i++) {
            let node = this._children[i];
            node._level = this._level + 1;
            node._indentLevel = this._indentLevel + 1 + node._addIndent;
            node._setTree(value);
        }
    }
    _expandedStateChanged() {
        this._setExpanded(this._expandCtrler.selectedIndex == 1, true);
    }
    _cellMouseDown(evt) {
        if (this._tree && this.isFolder)
            this._tree.selection._expandedStatusInEvt = this._expanded;
    }
    _clickExpandButton(evt) {
        evt.stopPropagation();
    }
}
